/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, unref as _unref } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("确定");
import { apiUserSetNickname } from '@/api/user';
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, {
    emit: emits
  }) {
    const ruleFormNickNameRef = ref();
    const editNameForm = ref({
      username: ''
    });
    const editNameRules = reactive({
      username: {
        required: true,
        message: '请输入昵称',
        trigger: 'blur'
      }
    });
    const handleOk = async formEl => {
      if (!formEl) return;
      await formEl.validate(valid => {
        if (valid) {
          apiUserSetNickname({
            ...editNameForm.value
          }).then(res => {
            if (res.code === 0) {
              emits('success');
              ruleFormNickNameRef.value.resetFields();
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "editNickName"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_Teleport, {
          to: "#editNickName"
        }, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleOk(ruleFormNickNameRef.value))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })])), _createVNode(_component_el_form, {
          ref_key: "ruleFormNickNameRef",
          ref: ruleFormNickNameRef,
          model: editNameForm.value,
          rules: _unref(editNameRules),
          "label-width": "120px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "昵称",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: editNameForm.value.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editNameForm.value.username = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      });
    };
  }
});